import * as Sentry from '@sentry/browser';
import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import { lsToastService } from '..';

// eslint-disable-next-line import/prefer-default-export
export const lsErrorService = {
    /*
     * Takes an error object preferably with a message, level and data fields and sends the error
     * with appropriate severity to Sentry
     * @param {Object} error - Error being submitted
     * @param {string} error.message - Error message to be sent to Sentry
     * @param {string} error.level - Severity of the error, defaults to debug if none provided
     * @param {Object} error.extra - Full error object / additional data to be sent to Sentry
     */

    log({ error, showAlert = false }) {
        if (_.isError(error)) {
            Sentry.captureException(error);
        } else {
            Sentry.captureMessage(_.get(error, 'message', 'An unexpected error has occured'), {
                level: _.get(error, 'level', 'error'),
                extra: _.get(error, 'extra', {}),
            });
        }

        if (showAlert) {
            let message = _.get(error, 'message');
            if (!message || message === 'Invalid or Missing X-Auth-Token') {
                message = 'An unexpected error has occured';
            }

            lsToastService.open({
                message: message.replace('GraphQL error: ', ''),
                type: 'is-error',
            });
        }

        console.error(error);
    },

    setUserContext(params) {
        Sentry.configureScope((scope) => {
            const userParams = _.cloneDeep(params);
            if (userParams.user_id) {
                userParams.id = userParams.user_id;
                _.unset(userParams.user_id);
            }
            scope.setUser(params);
            return params;
        });
    },
};
